import type RootStore from "@stores/RootStore";
import { action, makeObservable, observable, runInAction } from 'mobx';
import { Connection, Proxy, hubConnection } from 'signalr-no-jquery';
import Order from '../models/list/Order';

export default class UserOrderHub {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;

        makeObservable(this, {
            //#region UI
            isLoading: observable,
            setIsLoading: action,
            //#endregion

            connection: observable,
            hub: observable,
            connectionState: observable,
            startConnection: action,
            subscribeToOrderHub: action,
            stopConnection: action,
            onConnectionDisconnected: action,
            onConnectionReconnecting: action,
        })
    }

    //#region UI

    isLoading: boolean = false;
    setIsLoading = (value: boolean) => {
        this.isLoading = value
    }

    //#endregion

    connection: Connection | null;
    hub: Proxy | null;
    connectionState: 'not-initialized' | 'connecting' | 'connected' | 'disconnected' | 'reconnecting' = "not-initialized";

    startConnection = async () => {
        try {
            const signalRApiUrl = `${process.env.REACT_APP_API_URL}/signalR`;

            const connection = hubConnection(signalRApiUrl);

            if (connection) {
                const hub = connection.createHubProxy('UserOrderHub');
                hub.on('orderUpdate', (order) => {
                    var parsedOrder: Order = JSON.parse(order);
                    this.rootStore.orderEditViewStore.onOrderUpdate(parsedOrder);
                });

                connection.disconnected(this.onConnectionDisconnected);
                connection.reconnecting(this.onConnectionReconnecting);

                await connection.start();

                runInAction(() => {
                    this.hub = hub;
                    this.connection = connection;
                })
            }
        } catch (error) {
            if (this.connectionState === 'not-initialized') {
                // this.rootStore.toastStore.alert("error", "Greška prilikom konekcije.");
            }
        }
    }

    subscribeToOrderHub = async () => {
        if (this.connectionState === "connected") {
            return;
        }

        if (!this.connection) {
            await this.startConnection();
        }

        if (this.hub) {
            var subscribtionId = this.rootStore.orderEditViewStore.subscribtionId;

            if (subscribtionId === null) {
                alert("subscribtionId is null.");
                return;
            }

            this.hub.invoke('Subscribe', subscribtionId);
            var isSubscribed = true;

            if (isSubscribed) {
                runInAction(() => {
                    this.connectionState = "connected";
                })
            }
        }
        else {
            if (this.connectionState === 'not-initialized') {
                alert("Dogodila se greška. Molimo ponovo pokrenite kasu!");
            }
        }
    }

    stopConnection = () => {
        if (this.connection) {
            this.connectionState = 'not-initialized';
            this.connection.stop();

            runInAction(() => {
                this.connection = null;
                this.hub = null;
            })
        }
    }

    onConnectionDisconnected = () => {
        if (this.connectionState === 'not-initialized') {
            return;
        }

        runInAction(() => {
            this.connectionState = "disconnected";
        })
    }

    onConnectionReconnecting = () => {
        runInAction(() => {
            this.connectionState = "reconnecting";
        })
    }
}